/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Backend_Development_Doc_Desc3Inputs */

const en_svc_backend_development_doc_desc3 = /** @type {(inputs: Svc_Backend_Development_Doc_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-generated docs and contract tests so consumers never guess, and breaking changes get caught in CI.`)
};

const ar_svc_backend_development_doc_desc3 = /** @type {(inputs: Svc_Backend_Development_Doc_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`توثيق مولَّد تلقائيًا واختبارات عقود حتى لا يخمن المستهلكون أبدًا، وتُلتقط التغييرات الكاسرة في CI.`)
};

const bn_svc_backend_development_doc_desc3 = /** @type {(inputs: Svc_Backend_Development_Doc_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অটো-জেনারেটেড ডক ও কন্ট্রাক্ট টেস্ট, ভোক্তারা কখনো অনুমান করবে না, ব্রেকিং চেঞ্জ CI-তে ধরা পড়বে।`)
};

const de_svc_backend_development_doc_desc3 = /** @type {(inputs: Svc_Backend_Development_Doc_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisch generierte Dokumentation und Vertragstests, damit Verbraucher nie raten müssen und Breaking Changes im CI auffallen.`)
};

const es_svc_backend_development_doc_desc3 = /** @type {(inputs: Svc_Backend_Development_Doc_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentos generados automáticamente y pruebas de contrato para que los consumidores nunca adivinen y los breaking changes queden atrapados en la CI.`)
};

const fr_svc_backend_development_doc_desc3 = /** @type {(inputs: Svc_Backend_Development_Doc_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documents générés automatiquement et tests contractuels pour que les consommateurs ne devinent jamais et que les breaking changes soient captés dans la CI.`)
};

const pt_svc_backend_development_doc_desc3 = /** @type {(inputs: Svc_Backend_Development_Doc_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentos e testes de contrato gerados automaticamente para que os consumidores nunca adivinhem e breaking changes sejam detectados no CI.`)
};

const zh_svc_backend_development_doc_desc3 = /** @type {(inputs: Svc_Backend_Development_Doc_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动生成文档和契约测试，调用方不用猜，破坏性变更在 CI 里就被抓住。`)
};

const tr_svc_backend_development_doc_desc3 = /** @type {(inputs: Svc_Backend_Development_Doc_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otomatik üretilen belgeler ve sözleşme testleriyle tüketiciler tahmin etmez, breaking change'ler CI'da yakalanır.`)
};

const ru_svc_backend_development_doc_desc3 = /** @type {(inputs: Svc_Backend_Development_Doc_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автогенерённые доки и контрактные тесты, чтобы потребители не гадали, а брейкинг-чейнджи ловились в CI.`)
};

const pl_svc_backend_development_doc_desc3 = /** @type {(inputs: Svc_Backend_Development_Doc_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumenty generowane automatycznie i testy kontraktów, konsumenci nigdy nie zgadują, a breaking change'e łapią się w CI.`)
};

/**
* | output |
* | --- |
* | "Auto-generated docs and contract tests so consumers never guess, and breaking changes get caught in CI." |
*
* @param {Svc_Backend_Development_Doc_Desc3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_backend_development_doc_desc3 = /** @type {((inputs?: Svc_Backend_Development_Doc_Desc3Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Backend_Development_Doc_Desc3Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_backend_development_doc_desc3(inputs)
	if (locale === "bn") return bn_svc_backend_development_doc_desc3(inputs)
	if (locale === "de") return de_svc_backend_development_doc_desc3(inputs)
	if (locale === "es") return es_svc_backend_development_doc_desc3(inputs)
	if (locale === "fr") return fr_svc_backend_development_doc_desc3(inputs)
	if (locale === "pt") return pt_svc_backend_development_doc_desc3(inputs)
	if (locale === "zh") return zh_svc_backend_development_doc_desc3(inputs)
	if (locale === "tr") return tr_svc_backend_development_doc_desc3(inputs)
	if (locale === "ru") return ru_svc_backend_development_doc_desc3(inputs)
	if (locale === "pl") return pl_svc_backend_development_doc_desc3(inputs)
	return en_svc_backend_development_doc_desc3(inputs)
});
export { svc_backend_development_doc_desc3 as "svc_backend-development_DOC_desc" }